
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Vue from "vue"
import { BENEFIT_ICONS } from "@/constants/progressionActions"

export type BadgeTableItem = {
  slug: string
  title: string
  description: string
  progress: number
  actionsLabel: string
  benefits: string[]
  ctaLabel: string
}

export default Vue.extend({
  name: "ProgressBadgeTable",
  emits: ["badge-click"],
  props: {
    tableTitle: { type: String, default: "" },
    items: { type: Array as () => BadgeTableItem[], default: () => [] },
    headers: { type: Array, default: () => [] },
  },
  data: () => ({
    benefitIcons: BENEFIT_ICONS,
  }),
  methods: {
    onRowClick(item: BadgeTableItem) {
      this.$emit("badge-click", item.slug)
    },
    onCtaClick(item: BadgeTableItem) {
      this.$emit("badge-click", item.slug)
    },
  },
})
